import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconDefinition, faQuestion } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { AgentGreetingSettingsSelector } from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.selector';
import { AudioFileInfo } from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.state';

@Component({
   selector: 'samweb-agent-greeting-wave',
   templateUrl: './agent-greeting-wave.component.html',
   styleUrls: ['./agent-greeting-wave.component.scss'],
})
export class AgentGreetingWaveComponent implements OnInit {
   constructor(public store: Store) {}

   public waveIconNoLink: IconDefinition = faQuestion;
   public waveIcon: IconDefinition = WellKnownIconsEnum.GREETING_FILE.iconSmall;

   public clearFilterIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   public isLinked$: Observable<boolean>;

   @Input()
   public wave: AudioFileInfo;

   @Input()
   public displayClear = true;

   @Input()
   public tooltipTranslation: string;

   @Input()
   public searchValues: string[];

   @Output()
   public removeWave = new EventEmitter<AudioFileInfo>();

   ngOnInit(): void {
      this.isLinked$ = this.store.select(AgentGreetingSettingsSelector.getIsWaveAssigned).pipe(map((getIsAssigned) => getIsAssigned(this.wave?.id)));
   }

   public clear() {
      this.removeWave.emit(this.wave);
   }
}
